export interface SpinnerProps {
  centered?: boolean
  isLarge?: boolean
  className?: string
}

export default function Spinner({
  centered,
  isLarge,
  className
}: SpinnerProps) {
  return (
    <div
      className={`${centered && '!w-[40px] '} ${className} ${
        isLarge && 'my-8 !w-[76px]'
      } lds-ring`}
    >
      <div className={`${isLarge && '!h-16 !w-16'}`}></div>
      <div className={`${isLarge && '!h-16 !w-16'}`}></div>
      <div className={`${isLarge && '!h-16 !w-16'}`}></div>
      <div className={`${isLarge && '!h-16 !w-16'}`}></div>
    </div>
  )
}
